import { IconName } from '../components/ui/Icon';
import energyHero from '../assets/energy_hero.png';
import vehiclesHero from '../assets/vehicles_hero.png';
import furnitureHero from '../assets/furniture_hero.png';
import campingHero from '../assets/camping_hero.png';
import foodHero from '../assets/food_hero.png';
import kitchenHero from '../assets/kitchen_hero.png';
import agricultureHero from '../assets/agriculture_hero.png';
import buildingHero from '../assets/building_hero.png';

export interface Sector {
    id: string;
    title: string;
    description: string;
    content: string;
    icon: IconName;
    image?: string;
    features: string[];
}

export const sectorsData: Record<string, Sector> = {
    'energy': {
        id: 'energy',
        title: 'Energy',
        description: 'Leading exporter of solar power, generators, and sustainable energy solutions.',
        content: `Easy Buy is a leading exporter of solar power and Generators with a proven track record of successful international exports. We pride ourselves on delivering high-quality products that meet our customers' needs and beyond. We understand the growing demand for sustainable energy solutions in Africa, and we provide innovative and reliable products. We offer a wide range of solar power that are engineered to provide efficient power solutions for various applications, such as residential, commercial, and industrial projects.

Our home & outdoor EV charging poles are also highly efficient and reliable, it provides a constant supply of charge to our customers. We also offer generators, ensuring that our clients have access to the best options that meet their specific needs. We take great pride in our reputation as a trusted supplier of solar and generator power.`,
        icon: 'zap',
        image: energyHero,
        features: [
            'Solar Power Systems (Residential, Commercial, Industrial)',
            'Generators & Power Solutions',
            'EV Charging Poles (Home & Outdoor)',
            'Sustainable Energy Projects'
        ]
    },
    'vehicles-spare-parts': {
        id: 'vehicles-spare-parts',
        title: 'Vehicles & Spare Parts',
        description: 'Reputable automobile and auto components seller (light & heavy).',
        content: `Easy Buy is a reputable and well-known automobile and auto components seller (light & heavy). Focusing on our years of expertise in the vehicles and auto parts distribution, we understand our clients' needs and can provide the best authentic spare parts and automobiles to meet those needs for all well-known worldwide car brands.`,
        icon: 'truck',
        image: vehiclesHero,
        features: [
            'Light & Heavy Vehicles',
            'Authentic Spare Parts',
            'Worldwide Car Brands',
            'Auto Parts Distribution'
        ]
    },
    'furniture-appliances': {
        id: 'furniture-appliances',
        title: 'Furniture & Appliances',
        description: 'Expert in supplying high-quality indoor and outdoor home and office furnishings.',
        content: `Easy buy is an expert in supplying high-quality indoor and outdoor home and office furnishings. We satisfy well-designed ideas with style and create attractive ambiences by collaborating directly with developers and customers.
We take pleasure in providing high-quality products at reasonable pricing, as well as excellent client support and on-time shipping.`,
        icon: 'home',
        image: furnitureHero,
        features: [
            'Indoor & Outdoor Furnishings',
            'Home & Office Solutions',
            'High-Quality Products',
            'Excellent Client Support'
        ]
    },
    'camping-material': {
        id: 'camping-material',
        title: 'Camping Materials',
        description: 'Key role in sourcing camping materials such as tents and camper vans.',
        content: `Easy Buy also plays a key role in sourcing camping materials such as tents and camper vans. We as a supplier source, understand how crucial it is to find the right quality camping materials to be sourced.
The tents we source are available in a variety of sizes and styles, from lightweight backpacking tents to family-sized camping tents. We also supply varieties of camper vans that are user-friendly.`,
        icon: 'tent',
        image: campingHero,
        features: [
            'High-Quality Tents (All Sizes)',
            'User-Friendly Camper Vans',
            'Backpacking & Family Tents',
            'Reliable Camping Gear'
        ]
    },
    'food-items': {
        id: 'food-items',
        title: 'Food Items',
        description: 'Leading supplier of premium quality spices and canned foods.',
        content: `Easy buy is the leading supplier of premium quality spices and canned foods. Our company is committed to sourcing the highest standards of quality, freshness, and purity in the products.

We have a wide range of spices, including black pepper, cinnamon, cardamom, turmeric, cumin, cloves, and many more. We also offer a range of canned food products, such as canned fruits, vegetables, seafood, and meats.`,
        icon: 'shopping-cart',
        image: foodHero,
        features: [
            'Premium Quality Spices',
            'Canned Fruits & Vegetables',
            'Seafood & Meats',
            'Freshness & Purity Guaranteed'
        ]
    },
    'kitchen-bakery-equipment': {
        id: 'kitchen-bakery-equipment',
        title: 'Kitchen & Bakery Equipment',
        description: 'Dependable supplier of high-quality bakery and kitchen equipment.',
        content: `Easy Buy has recently begun to concentrate on bakery and kitchen equipment supplies. We have developed a reputation as a dependable and trustworthy supplier of high-quality, thanks to our years of experience in the field.
We are committed to providing our clients with the latest and most innovative kitchen and bakery equipment to meet their specific needs. We work with the world's leading manufacturers to ensure that the supplies meet the highest standards of quality and durability.`,
        icon: 'coffee',
        image: kitchenHero,
        features: [
            'Industrial Bakery Equipment',
            'Commercial Kitchen Supplies',
            'Innovative Machinery',
            'High Quality & Durability'
        ]
    },
    'agriculture-irrigation-equipment': {
        id: 'agriculture-irrigation-equipment',
        title: 'Agriculture & Irrigation Equipment',
        description: 'Dedicated to source top-quality agricultural equipment and irrigation systems.',
        content: `Easy Buy is also dedicated to source top-quality agricultural equipment; including tractors, harvesters, plows, and tillers, from reputable manufacturers. We also offer efficient and cost-effective irrigation systems, fertilizers, pesticides, and high-quality seeds of various varieties to meet the specific needs of crops.
Our range includes cattle and poultry feed and equipment, mesh and plastic covers to protect crops, and state-of-the-art greenhouses to help farmers grow crops year-round in a controlled environment.`,
        icon: 'sun',
        image: agricultureHero,
        features: [
            'Tractors & Harvesters',
            'Irrigation Systems & Fertilizers',
            'Greenhouses & Crop Protection',
            'Poultry & Cattle Equipment'
        ]
    },
    'building-material': {
        id: 'building-material',
        title: 'Building Materials',
        description: 'Specializes in sourcing high-quality building materials such as sanitary wares and tiles.',
        content: `Easy Buy furthermore specializes in sourcing high-quality building materials such as sanitary wares, floor and wall tiles, valves, and faucets. When talking about sanitary wares, they can be used in toilets and sinks, showers and bidets, they also offer a wide range of products that are stylish, durable, and practical.

In addition, we also source the high-quality floor and wall tiles, from ceramic and porcelain tiles to marbles and granites, as well as a wide array of valves and faucets, which are essential components of any plumbing system.`,
        icon: 'box',
        image: buildingHero,
        features: [
            'Sanitary Wares & Faucets',
            'Floor (Ceramic, Porcelain) & Wall Tiles',
            'Marbles & Granites',
            'Valves & Plumbing Components'
        ]
    }
};
